import * as React from 'react';
import {faAngleDown, faAngleUp} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {AdditionalSpecValue, Item, TechSpecValue} from '../item.class';
import {useState} from 'react';
import Button from '../../ui/Buttons/Button';
import {PageHeader} from '../../ui/PageHeader/PageHeader';

type TechSpecsProps = {
    item: Item;
};
interface TechSpecRow {
    left: TechSpecValue;
    right?: TechSpecValue;
}

export const TechSpecs = ({item}: TechSpecsProps) => {
    const [showMore, setShowMore] = useState(false);
    const convertAdditional = (additionalSpecs: AdditionalSpecValue[]): TechSpecValue[] => {
        return additionalSpecs.map((spec) => {
            return {facetName: spec.name, facetValue: spec.value};
        });
    };
    const outputTable = (techSpecs: TechSpecValue[]) => {
        const techSpecRows: TechSpecRow[] = [];
        const techSpecLength = techSpecs.length;
        const parity = techSpecLength % 2 === 1;
        let offset = techSpecLength / 2;
        if (parity) {
            offset += 0.5;
        }
        for (let i = 0; parity ? i < offset : i < offset; i++) {
            techSpecRows.push({left: techSpecs[i], right: techSpecs[i + offset]});
        }
        return techSpecRows.map((tsRow, index) => (
            <div
                className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4"
                key={index}
            >
                <div className="tw-border-b py-2 tw-grid tw-grid-cols-2">
                    <div className="tw-font-extrabold">{tsRow.left.facetName}</div>
                    <div>{tsRow.left.facetValue}</div>
                </div>

                {tsRow.right && (
                    <div className="tw-border-b py-2 tw-grid tw-grid-cols-2">
                        <div className="tw-font-extrabold">{tsRow.right.facetName}</div>
                        <div>{tsRow.right.facetValue}</div>
                    </div>
                )}
            </div>
        ));
    };

    return (
        <div
            className="tw-mb-8"
            data-e2e="TechnicalSpecificationText"
        >
            <PageHeader
                title="Technical Specifications"
                type="h4"
            />
            {item.additionalSpecs?.length > 0 && (
                <h5
                    className="tw-mt-2"
                    data-e2e="keySpecificationText"
                >
                    Key Specifications
                </h5>
            )}
            <div
                className="tw-p-3 tw-bg-gray-100"
                data-e2e="keySpecificationsDetails"
            >
                {outputTable(item.techSpecs)}
            </div>
            {item.additionalSpecs?.length > 0 && (
                <>
                    <div className="tw-block md:!tw-hidden tw-mt-3">
                        <Button
                            variant="outline-secondary"
                            className="tw-w-full"
                            onClick={() => {
                                setShowMore(!showMore);
                            }}
                            size="sm"
                        >
                            See {showMore ? 'Less' : 'More'} Technical Specifications{' '}
                            <FontAwesomeIcon
                                icon={showMore ? faAngleUp : faAngleDown}
                                suppressHydrationWarning
                            />
                        </Button>
                    </div>
                    <div className={`${showMore ? '' : 'tw-hidden '}md:tw-block`}>
                        <h5 className="tw-mt-3">General</h5>
                        <div className="tw-p-3 tw-bg-gray-100">{outputTable(convertAdditional(item.additionalSpecs))}</div>
                    </div>
                </>
            )}
        </div>
    );
};
